export const customToastStyle = {
  icon: "⚠",
  style: {
    borderRadius: "10px",
    background: "#333",
    color: "#fff",
  },
};

export const customToastSuccessStyle = {
  icon: "✔",
  style: {
    borderRadius: "10px",
    background: "#333",
    color: "#fff",
  },
};

export const customModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

export const FAUCET_URL = "https://faucets.chain.link/polygon-amoy";

export const METAMASK_EXTENSION_LINK =
  "https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn";

export const CHAIN_ID = "0x13882";

export const RPC_URL = "https://rpc-amoy.polygon.technology";

export const CHAIN_NAME = "Amoy Testnet"


export const CHAIN_NATIVE_CURRENCY = {
  name: "MATIC",
  symbol: "MATIC",
  decimals: 18
}

export const CHAIN_BLOCK_EXPLORER_URLS = ["https://www.oklink.com/amoy"]

export const ANKR_NETWORK = "polygon_amoy";

export const ANKR_KEY = "75cdf706b4b73d10fdb62a6603cb74428a8a24542cd0b785cd2c18a7849eb5cc";